/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import PhysicalObjectType from './PhysicalObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="isUnique" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="indexedColumn" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="sortOrder" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Index extends PhysicalObjectType{

	isUnique = null;

	indexedColumn = null;



	/**
	 * Gets the value of the isUnique property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isIsUnique() {
		return this.isUnique;
	}

	/**
	 * Sets the value of the isUnique property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setIsUnique(value) {
		var oldValue = this.isUnique;
		this.isUnique = value;
		this._setAndNotify(1, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the indexedColumn property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the indexedColumn property. <p> For example, to add a new item, do as follows: <pre> getIndexedColumn().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Index.IndexedColumn}
	 */
	getIndexedColumn() {
		if (!this.indexedColumn) {
			this.indexedColumn = [];
		}
		return this.indexedColumn;
	}

	/**
	 * Gets the value of the <code>indexedColumn</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>IndexedColumn</code> elements, or <code>null</code> if not set
	 */
	basicGetIndexedColumn() {
		return this.indexedColumn;
	}

	/**
	 * Creates a new instance of <code>Index</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Index</code> object from.
	 * @return {Index} an object of type <code>Index</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createIndex();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addIndexedColumnAt(position, item) {
		this._addAtAndNotify(this.getIndexedColumn(), position, item, 2, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addIndexedColumn(item) {
		this.addIndexedColumnAt(this.getIndexedColumn().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeIndexedColumnAt(position) {
		this._removeAtAndNotify(this.getIndexedColumn(), position, 2, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeIndexedColumn(item) {
		var i = this.getIndexedColumn().indexOf(item);
		if (i >= 0) {
			this.removeIndexedColumnAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Index";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 1, "isUnique", null));
		var clazz;
		if (factory) {
			clazz = factory.createIndexIndexedColumn().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 2, "indexedColumn", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 1:
			this.setIsUnique((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 2:
			this.indexedColumn = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 1:
			return this.isIsUnique();
		case 2:
			return this.getIndexedColumn();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 1:
			return this.isIsUnique();
		case 2:
			return this.basicGetIndexedColumn();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 2:
			this.addIndexedColumnAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 2:
			this.addIndexedColumn((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 2:
			this.removeIndexedColumnAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 2:
			this.removeIndexedColumn((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="sortOrder" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
Index.IndexedColumn = class extends MoserObject{

	columnName = null;

	sortOrder = null;



	/**
	 * Gets the value of the columnName property.
	 * @return {String} possible object is {@link String}
	 */
	getColumnName() {
		return this.columnName;
	}

	/**
	 * Sets the value of the columnName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setColumnName(value) {
		var oldValue = this.columnName;
		this.columnName = value;
		this._setAndNotify(144, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the sortOrder property.
	 * @return {String} possible object is {@link String}
	 */
	getSortOrder() {
		return this.sortOrder;
	}

	/**
	 * Sets the value of the sortOrder property.
	 * @param {String} value allowed object is {@link String}
	 */
	setSortOrder(value) {
		var oldValue = this.sortOrder;
		this.sortOrder = value;
		this._setAndNotify(145, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>IndexedColumn</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> IndexedColumn</code> object from.
	 * @return {IndexedColumn} an object of type <code>IndexedColumn</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createIndexIndexedColumn();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "IndexedColumn";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 144, "columnName", null));
		featureList.push(this.createFeature(false, false, false, 145, "sortOrder", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 144:
			this.setColumnName((value));
			break;
		case 145:
			this.setSortOrder((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 144:
			return this.getColumnName();
		case 145:
			return this.getSortOrder();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 144:
			return this.getColumnName();
		case 145:
			return this.getSortOrder();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/Index.js